import { __assign, __extends, __makeTemplateObject } from "tslib";
import React from 'react';
import SortableTree, { toggleExpandedForAll, changeNodeAtPath } from 'react-sortable-tree';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { Button } from 'info-ui-library';
import cloneDeep from 'lodash/cloneDeep';
import FileExplorerTheme from 'react-sortable-tree-theme-file-explorer';
import 'react-sortable-tree/style.css';
import styled from 'styled-components';
import { resolveColor } from '../ThemeOptions';
import '../../../../node_modules/font-awesome/css/font-awesome.min.css';
import '../../../../node_modules/react-bootstrap/dist/react-bootstrap.min.js';
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { themes } from '../ThemeOptions';
var StyledLabel = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject([" \n    color: ", ";\n"], [" \n    color: ",
    ";\n"])), function (p) {
    return p.type === 'Leaf' ? '#dc3545cf' :
        resolveColor(p.ioTheme, p.ioMode, p.styleName, 'background');
});
var WrapperContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    height: 100%;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n"], ["\n    height: 100%;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n"])));
var BarWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-top: 5px;\n    margin-left: 5px;\n    margin-bottom: 5px;\n"], ["\n    margin-top: 5px;\n    margin-left: 5px;\n    margin-bottom: 5px;\n"])));
var TreeWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    height: calc(100% - 25px);\n"], ["\n    height: calc(100% - 25px);\n"])));
var StyledDropdownButton = styled(DropdownButton)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        display: inline-block;\n        margin-right: 4px;\n"], ["\n        display: inline-block;\n        margin-right: 4px;\n"])));
var Tree = /** @class */ (function (_super) {
    __extends(Tree, _super);
    function Tree(props) {
        var _this = _super.call(this, props) || this;
        _this.handleTreeOnChange = function (treeData) {
            _this.setState({ treeData: treeData });
        };
        _this.toggleNodeExpansion = function (expanded) {
            var treeData = cloneDeep(_this.state.treeData);
            if (expanded) {
                treeData = _this.expandDataMaker(treeData, expanded);
                _this.setState({
                    treeData: treeData
                });
            }
            else {
                treeData = _this.collapseDataMaker(treeData, expanded);
                _this.setState({
                    treeData: treeData
                });
            }
        };
        _this.toggleNodeExpansionAll = function (expanded) {
            _this.setState(function (prevState) { return ({
                treeData: toggleExpandedForAll({ treeData: prevState.treeData, expanded: expanded })
            }); });
        };
        _this.state = {
            treeData: _this.props.treeData.returnData.sortableTreeData,
            enableExpandButton: _this.props.enableExpandButton,
            enableCollapseButton: _this.props.enableCollapseButton,
            enableExpandALLButton: _this.props.enableExpandALLButton,
            enableCollapseAllButton: _this.props.enableCollapseAllButton,
            enableExpandLevelButton: _this.props.enableExpandLevelButton,
            enableCollapseLevelButton: _this.props.enableCollapseLevelButton,
            levelCount: _this.props.levelCount
        };
        return _this;
    }
    Tree.prototype.componentWillReceiveProps = function (nextProps) {
        this.setState({
            treeData: nextProps.treeData.returnData.sortableTreeData,
            enableExpandButton: nextProps.enableExpandButton,
            enableCollapseButton: nextProps.enableCollapseButton,
            enableExpandALLButton: nextProps.enableExpandALLButton,
            enableCollapseAllButton: nextProps.enableCollapseAllButton,
            enableExpandLevelButton: nextProps.enableExpandLevelButton,
            enableCollapseLevelButton: nextProps.enableCollapseLevelButton,
            levelCount: nextProps.LevelCount
        });
    };
    Tree.prototype.rowHeight = function (node) {
        var heightCount = 0;
        heightCount = (node.title.length + 3) * 8 / 1200;
        var heightCounter = node.title.split('\n');
        if (heightCount <= 1 && heightCounter.length === 1) {
            return 35;
        }
        else if (heightCount <= 2 && heightCounter.length === 2) {
            return 55;
        }
        else if (heightCount <= 3 && heightCounter.length === 3) {
            return 75;
        }
        else if (heightCount <= 4 && heightCounter.length === 4) {
            return 95;
        }
        else {
            return 125;
        }
    };
    Tree.prototype.handleOnClick = function (node, path) {
        var data = cloneDeep(this.state.treeData);
        var getNodeKey = function (_a) {
            var treeIndex = _a.treeIndex;
            return treeIndex;
        };
        if (node.expanded && node.type === "Node" && this.props.collapseOnClick) {
            var Node_1 = this.collapseLevelWiseDataMaker([node], node.level, !node.expanded);
            var modifiedNode_1 = Node_1[0];
            this.setState(function () { return ({
                treeData: changeNodeAtPath({
                    treeData: data,
                    path: path,
                    getNodeKey: getNodeKey,
                    newNode: __assign({}, modifiedNode_1),
                }),
            }); });
        }
        else {
            if (this.props.expandOnClick) {
                this.setState(function () { return ({
                    treeData: changeNodeAtPath({
                        treeData: data,
                        path: path,
                        getNodeKey: getNodeKey,
                        newNode: __assign(__assign({}, node), { expanded: true }),
                    }),
                }); });
            }
            else if (this.props.collapseOnClick) {
                this.setState(function () { return ({
                    treeData: changeNodeAtPath({
                        treeData: data,
                        path: path,
                        getNodeKey: getNodeKey,
                        newNode: __assign(__assign({}, node), { expanded: false }),
                    }),
                }); });
            }
        }
        this.props.onClick(node, this.state.treeData);
    };
    Tree.prototype.expandDataMaker = function (treeData, expanded) {
        var _this = this;
        treeData.map(function (parent) {
            if (parent.expanded !== expanded) {
                parent.expanded = expanded;
            }
            else if (parent.expanded === expanded && parent.children !== undefined && parent.children !== null) {
                _this.expandDataMaker(parent.children, expanded);
            }
            return null;
        });
        return treeData;
    };
    Tree.prototype.collapseDataMaker = function (treeData, expanded) {
        var _this = this;
        var isDirty = false;
        treeData.map(function (parent) {
            if (parent.expanded !== expanded) {
                isDirty = _this.collapseDataMakerFactory(parent, expanded);
                if (parent.expanded !== expanded && !isDirty) {
                    parent.expanded = expanded;
                }
            }
            return null;
        });
        return treeData;
    };
    Tree.prototype.collapseDataMakerFactory = function (treeData, expanded) {
        var isDirty = false;
        var isDirty1 = false;
        if (treeData.hasOwnProperty("children") && treeData.children.length > 0 && treeData.expanded !== expanded) {
            var i = 0;
            for (i = 0; i < treeData.children.length; i++) {
                isDirty1 = isDirty1 || this.collapseDataMakerFactory(treeData.children[i], expanded);
                if (treeData.children[i]["expanded"] !== expanded && !isDirty1) {
                    treeData.children[i]["expanded"] = expanded;
                    isDirty = true;
                }
            }
            return isDirty || isDirty1;
        }
        else if (treeData.expanded !== expanded) {
            treeData.expanded = expanded;
            return false;
        }
    };
    Tree.prototype.toggleLevelExpansion = function (level, expanded) {
        var treeData = cloneDeep(this.state.treeData);
        if (expanded) {
            treeData = this.expandLevelWiseDataMaker(treeData, level, expanded);
            this.setState({
                treeData: treeData
            });
        }
        else {
            treeData = this.collapseLevelWiseDataMaker(treeData, level, expanded);
            this.setState({
                treeData: treeData
            });
        }
    };
    Tree.prototype.expandLevelWiseDataMaker = function (treeData, level, expanded) {
        var _this = this;
        treeData.map(function (parent) {
            if (parent.level <= level) {
                parent.expanded = expanded;
            }
            if (parent.children !== undefined && parent.children !== null) {
                _this.expandLevelWiseDataMaker(parent.children, level, expanded);
            }
            return null;
        });
        return treeData;
    };
    Tree.prototype.collapseLevelWiseDataMaker = function (treeData, level, expanded) {
        var _this = this;
        treeData.map(function (parent) {
            if (parent.level >= level) {
                parent.expanded = expanded;
            }
            if (parent.children !== undefined && parent.children !== null) {
                _this.collapseLevelWiseDataMaker(parent.children, level, expanded);
            }
            return null;
        });
        return treeData;
    };
    Tree.prototype.render = function () {
        var _this = this;
        var _a = this.state, treeData = _a.treeData, enableExpandButton = _a.enableExpandButton, enableCollapseButton = _a.enableCollapseButton, enableExpandALLButton = _a.enableExpandALLButton, enableCollapseAllButton = _a.enableCollapseAllButton, enableExpandLevelButton = _a.enableExpandLevelButton, enableCollapseLevelButton = _a.enableCollapseLevelButton, levelCount = _a.levelCount;
        var expandButton = [];
        var expandAllButton = [];
        var expandLevelButton = [];
        var collapseButton = [];
        var collapseAllButton = [];
        var collapseLevelButton = [];
        if (enableExpandButton) {
            expandButton.push(React.createElement(Button, { ioTheme: this.props.ioTheme, ioMode: this.props.ioMode, styleName: this.props.styleName, name: "", id: "ExpandButton", className: "fa fa-plus", title: "Expand", onClick: this.toggleNodeExpansion.bind(this, true), key: "ExpandButton" }));
        }
        if (enableCollapseButton) {
            collapseButton.push(React.createElement(Button, { ioTheme: this.props.ioTheme, ioMode: this.props.ioMode, styleName: this.props.styleName, name: "", id: "CollapseButton", className: "fa fa-minus", title: "Collapse", onClick: this.toggleNodeExpansion.bind(this, false), key: "CollapseButton" }));
        }
        if (enableExpandALLButton) {
            expandAllButton.push(React.createElement(Button, { ioTheme: this.props.ioTheme, ioMode: this.props.ioMode, styleName: this.props.styleName, name: "", id: "ExpandAllButton", className: "fa fa-expand", title: "Expand All", onClick: this.toggleNodeExpansionAll.bind(this, true), key: "ExpandAllButton" }));
        }
        if (enableCollapseAllButton) {
            collapseAllButton.push(React.createElement(Button, { ioTheme: this.props.ioTheme, ioMode: this.props.ioMode, styleName: this.props.styleName, name: "", id: "CollapseAllButton", className: "fa fa-compress", title: "Collapse All", onClick: this.toggleNodeExpansionAll.bind(this, false), key: "CollapseAllButton" }));
        }
        if (levelCount > 0 && (enableExpandLevelButton || enableCollapseLevelButton)) {
            var expandAnchorTag = [];
            var collapseAnchorTag = [];
            var i = 1;
            for (i = 1; i < levelCount; i++) {
                var labelValue = "Level " + i;
                expandAnchorTag.push(React.createElement(Dropdown.Item, { onClick: this.toggleLevelExpansion.bind(this, i, true), key: i }, labelValue));
                collapseAnchorTag.push(React.createElement(Dropdown.Item, { onClick: this.toggleLevelExpansion.bind(this, i, false), key: i }, labelValue));
            }
            if (enableExpandLevelButton) {
                expandLevelButton.push(React.createElement(StyledDropdownButton, { drop: 'down', variant: "secondary", title: "Expand", id: "dropdown-button-1", key: 'down' }, expandAnchorTag));
            }
            if (enableCollapseLevelButton) {
                collapseLevelButton.push(React.createElement(StyledDropdownButton, { drop: 'down', variant: "secondary", title: "Collapse", id: "dropdown-button-2", key: 'down' }, collapseAnchorTag));
            }
        }
        return (React.createElement(WrapperContainer, null,
            React.createElement(BarWrapper, null,
                expandButton,
                collapseButton,
                expandAllButton,
                collapseAllButton,
                expandLevelButton,
                collapseLevelButton),
            React.createElement(TreeWrapper, null,
                React.createElement(SortableTree, { isVirtualized: false, treeData: treeData, onChange: this.handleTreeOnChange, canDrag: false, theme: FileExplorerTheme, rowHeight: function (_a) {
                        var node = _a.node;
                        return _this.rowHeight(node);
                    }, generateNodeProps: function (_a) {
                        var node = _a.node, path = _a.path;
                        return ({
                            title: (React.createElement(StyledLabel, { ioTheme: _this.props.ioTheme, ioMode: _this.props.ioMode, styleName: _this.props.styleName, id: node.id, type: node.type, onClick: function () { return _this.handleOnClick(node, path); } }, node.title))
                        });
                    } }))));
    };
    Tree.defaultProps = {
        styleName: 'primary',
        ioTheme: themes[0],
        ioMode: 'light',
        name: 'SideTreeNavigation'
    };
    return Tree;
}(React.Component));
export default Tree;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=ddlTreeWithFileTheme.js.map